import React from "react";

const ComponentLoading = () => {
    return <p className="py-6 text-center">Loading ... </p>;
};

export default ComponentLoading;
